ReceivedGiftCard: Ha recibido una tarjeta de regalo
HaveGiftCard: Tiene una tarjeta de regalo
Sender: 'Remitente: {0}'
IssuedDate: 'Fecha de emisión: {0}'
Expires: 'Caduca: {0}'
Close: Cerrar
Refuse: Rechazar
Accept: Aceptar
